import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { socialProofMessages } from '../data/content';
const INTERVAL_MS = 15000;
const VISIBLE_MS = 6000;
export function SocialProofPopups() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), VISIBLE_MS);
    };
    const firstTimer = setTimeout(show, 5000);
    const cycle = setInterval(() => {
      setIndex(prev => (prev + 1) % socialProofMessages.length);
      show();
    }, INTERVAL_MS);
    return () => {
      clearTimeout(firstTimer);
      clearTimeout(hideTimer);
      clearInterval(cycle);
    };
  }, []);
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100%-2rem)] sm:max-w-sm" data-id="element-116" data-mp="3fnypoxmp24ll">
      <AnimatePresence data-id="element-117" data-mp="1b465dv3cee0a">
        {visible && <motion.div key={index} initial={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex items-center gap-3 rounded-xl border border-brand/15 bg-white px-4 py-3 shadow-xl shadow-brand/10" data-id="element-118" data-mp="1b1a725nl1nbb">
            <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-119" data-mp="w5lv1uc0vvwv" />
            <p className="text-left text-sm font-medium text-gray-800" data-id="element-120" data-mp="ificpeg9kmcp">
              {socialProofMessages[index]}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}